<template>
  <div id="games-containier" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-4" v-if="season_dropdown.data != undefined">
        <season-select v-model="seasons_selected" :options="season_dropdown"></season-select>
      </div>

      <div class="col-md-4" v-if="season_type_dropdown.data != undefined">
        <season-type-select v-model="season_type_selected" :options="season_type_dropdown"></season-type-select>
      </div>
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Get Games</button>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="table_data.length > 0">
        <vue-good-table
            :columns="table_columns"
            :rows="table_data"
            :pagination-options="{ enabled: true, perPage: 30}"
            :searchOptions="{ enabled: true}"
            :sort-options="{ enabled: true, initialSortBy: {field: 'Date', type: 'asc'}}"
            styleClass="vgt-table bordered striped">
            <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'Date'">
                <span :id="'popover-'+props.row.GameId" v-b-tooltip.hover title="Click For More">
                    {{props.formattedRow[props.column.field]}}
                </span>
                <b-popover
                    :target="'popover-'+props.row.GameId">
                    <template slot="title">{{props.row.AwayTeamAbbreviation}} @ {{ props.row.HomeTeamAbbreviation }}</template>
                    <ul>
                      <li><router-link :to="{ name: 'game_stats', params: { game_id: props.row.GameId, type: 'player' }}">Player Game Stats</router-link></li>
                      <li><router-link :to="{ name: 'game_stats', params: { game_id: props.row.GameId, type: 'lineup' }}">Lineup Game Stats</router-link></li>
                      <li><router-link :to="{ name: 'game_stats', params: { game_id: props.row.GameId, type: 'lineup-opponent' }}">Lineup Opponent Game Stats</router-link></li>
                      <li><router-link :to="{ name: 'assist_networks', params: { type: 'game', league: $route.params.league }, query: { GameId: props.row.GameId, TeamId: props.row.HomeTeamId}}">{{ props.row.HomeTeamAbbreviation }} Assist Network</router-link></li>
                      <li><router-link :to="{ name: 'assist_networks', params: { type: 'game', league: $route.params.league }, query: { GameId: props.row.GameId, TeamId: props.row.AwayTeamId}}">{{ props.row.AwayTeamAbbreviation }} Assist Network</router-link></li>
                    </ul>
                </b-popover>
            </div>
            <div v-else>
                <span>
                    {{props.formattedRow[props.column.field]}}
                </span>
            </div>
            </template>
            <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                {{props.column.label}}
            </span>
            <span v-else>
                {{props.column.label}}
            </span>
            </template>
        </vue-good-table>
    </div>
  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import { rateStats } from './mixins/rate_stats'
import { tableUtils } from './mixins/table_utils'
import SeasonTypeSelect from './mixins/SeasonTypeSelect.vue'
import SeasonSelect from './mixins/SeasonSelect.vue'
import { season, seasonType } from './mixins/dropdowns'

export default {
  name: 'Games',
  components: {
    Multiselect,
    SeasonTypeSelect,
    SeasonSelect
  },
  mixins: [rateStats, tableUtils, SeasonTypeSelect, SeasonSelect, GetDropdownOptions, season, seasonType],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      seasons_selected: [],
      season_type_dropdown: {},
      season_selected_string: '',
      season_type_selected: undefined,
      table_data: [],
      table_columns: [
        {'field': 'Date', 'label': 'Date', 'filterable': true, 'type': 'date', 'dateInputFormat': 'yyyy-MM-dd', 'dateOutputFormat': 'yyyy/MM/dd'},
        {'field': 'HomeTeamAbbreviation', 'label': 'Home', 'filterable': true},
        {'field': 'AwayTeamAbbreviation', 'label': 'Away', 'filterable': true},
        {'field': 'HomePoints', 'label': 'Home Points', 'type': 'number'},
        {'field': 'AwayPoints', 'label': 'Away Points', 'type': 'number'},
        {'field': 'HomePossessions', 'label': 'Home Possessions', 'type': 'number'},
        {'field': 'AwayPossessions', 'label': 'Away Possessions', 'type': 'number'}
      ],
      use_min_filters: false,
      use_text_filters: false,
      show_error_message: false,
      api_endpoint: 'get-games/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      this.season_dropdown = {}
      this.seasons_selected = []
      this.season_selected_string = ''
      this.table_data = []
      this.$router.push({name: 'games', params: {league: this.$parent.league}})
    },
    checkIfStatsShouldBeLoaded (response) {
      if (this.$route.query.Season && this.$route.query.SeasonType) {
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.checkIfStatsShouldBeLoaded])
    },
    updateData () {
      this.table_data = []
      if (this.$route.query.Season && this.$route.query.SeasonType) {
        // seat season selected on update in case url is changed without clicking the get stats button
        this.setSeasonsSelected()
        this.setSeasonTypeValue()
        this.season_selected_string = this.getSeasonsSelectedString()
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changeStats () {
      var params = {}

      this.season_selected_string = this.getSeasonsSelectedString()
      params[this.$seasonParam] = this.season_selected_string
      params[this.$seasonTypeParam] = this.season_type_selected.id

      this.$router.push({name: 'games', query: params})
    },
    getStats () {
      this.show_error_message = false
      this.table_data = []
      var params = this.$route.query
      if (params.Season && params.SeasonType) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.table_data = response.data.results
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    }
  }
}
</script>

<style scoped>
@import "https://maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css"

</style>



// WEBPACK FOOTER //
// src/components/Games.vue